/**
 * 判断字符串是否为图片 URL
 * @param {string} str
 * @returns {boolean}
 */
export function isImageUrl(str) {
  return /^https?:\/\/.+\.(png|jpg|jpeg|gif|webp|bmp|svg)(\?.*)?$/i.test(str)
}
